<template>
  <div v-if="typeInfo" class="alarm-type-icons" :title="typeInfo.name">
    <div class="alarm-type-icons__list">
      <StatusIcon v-if="typeInfo.isContinuous" type="continuous" title="連續" />
      <StatusIcon v-if="typeInfo.hasRain" type="rain" title="降雨" />
      <StatusIcon v-if="typeInfo.isTemp" type="temp" title="溫度" />
      <StatusIcon v-if="typeInfo.hasSimultaneous" type="simultaneous" title="同時" />
      <StatusIcon v-if="typeInfo.isRecovered === true" type="recovered" title="已回復" />
      <StatusIcon v-if="typeInfo.isRecovered === false" type="not-recovered" title="未回復" />
      <StatusIcon v-if="typeInfo.isSpike" type="spike" title="突波" />
    </div>
  </div>
  <span v-else class="alarm-type-icons--empty">-</span>
</template>

<script>
import StatusIcon from './StatusIcon.vue';
import alarmTypeMap from '@/utils/alarmTypeMap';

export default {
  name: 'AlarmTypeDisplay',
  components: { StatusIcon },
  props: {
    alarmType: {
      type: String,
      default: null,
    },
  },
  computed: {
    typeInfo() {
      if (!this.alarmType) return null;
      return alarmTypeMap[this.alarmType] || null;
    },
  },
};
</script>

<style scoped>
.alarm-type-icons__list {
  display: flex;
  align-items: center;
  gap: 3px;
  margin-top: 4px;
}

.alarm-type-icons--empty {
  color: #c0c4cc;
}
</style>